<template>
    <div class="view" :style="{paddingTop:navbarheight}">
        <div class="content">
            <my-top title="食堂采购" lefttext="返回" @leftclick="togo('/application')"></my-top>
            <cell>
                <template #title>
                    <span @click="visible=true">{{currentMonth}}<Icon name="arrow-down" /></span>
                </template>
            </cell>
            <pull-refresh v-model="refreshing" @refresh="onRefresh">
                <list class="cont-box"
                      v-model="loading"
                      :finished="finished"
                      finished-text="没有更多了"
                      @load="getlistdata">
                    <cell v-for="(item, n) in list" v-if="item.creatorId == userId" :key="n"  :title="item.meetTime || '无'" @click="togo('/application/canteen/purchase/form', {readonly:true, listId:item.id})">
                        <template>
                            <div>
                                <span v-if="item.totalMoney">￥{{item.totalMoney}}</span>
                                <span v-else>无</span>
                                <br>采购金额
                            </div>
                        </template>
                    </cell>
                </list>
            </pull-refresh>
            <!--<div style="text-align: center" v-if="loading">-->
                <!--<Loading color="#1989fa"></Loading>-->
            <!--</div>-->
            <Popup v-model="visible" position="bottom" >
                <datetimePicker
                        v-model="currentDate"
                        type="year-month"
                        title="选择年月"
                        :formatter="formatter"
                        @confirm="onRefresh"
                        @cancel="visible=false"
                />
            </Popup>
        </div>
        <div class="btnSub">
            <van-button block type="info" :loading="loadingSub" loading-text="校验中..." @click="handleSubmit">填写采购信息</van-button>
        </div>
    </div>
</template>

<script>
    import {Cell, DatetimePicker, Dialog, Icon, List, Popup, PullRefresh} from 'vant';
    import application from '@api/application';

    export default {
        name: "dinersNum",
        components: {Cell, Icon, DatetimePicker, Popup, List, PullRefresh, Dialog},
        data(){
            return{
                loading: false,
                loadingSub: false,
                finished: false,
                refreshing: false,
                visible:false,
                editVisible:false,
                currentDate: new Date(),
                currentMonth:this.formatYearDate(new Date(), '年')+'月',
                userId:JSON.parse(localStorage.getItem("vuex")).user.userInfo.userId,
                list:[],
                query: {
                    pageNo: 1,
                    pageSize: 5,
                    needCount: true,
                    query:{
                        meetQuery: this.formatYearDate(new Date()),
                        orgId: JSON.parse(localStorage.getItem("vuex")).user.company.deptId,
                    }
                },
            }
        },
        methods:{
            formatter(type, val) {
                if (type === 'year') {
                    return `${val}年`;
                } else if (type === 'month') {
                    return `${val}月`;
                }
                return val;
            },
            handleSubmit(){
                /**
                 * 获取采购供应商数据
                 **/
                let supplier;
                this.loadingSub = true;
                let form={
                    id:JSON.parse(localStorage.getItem("vuex")).user.company.id,
                    supId: '1' //1：食堂采购；0：食堂考核、用餐评价、用餐人数
                }
                application.getOfficeCanteenByOrgId(form).then(res =>{
                    if(res.code == 200){
                        supplier = res.data
                        if(supplier && supplier.length>1){
                            this.$router.push({
                                path: '/application/canteen/purchase/form',
                            })
                        }else {
                            Dialog.alert({
                                message: '您所属单位下无食堂信息，不能进行食堂采购',
                                closeOnClickOverlay: true
                            }).then(()=>{
                            })
                        }
                    }
                    this.loadingSub = false;
                }).catch(()=>{
                    this.loadingSub = false;
                })
            },
            /**
             * 获取列表
             **/
            // handleList(e){
            //     if(e){
            //         this.query.query.meetQuery = this.formatYearDate(e);
            //         this.currentMonth=this.formatYearDate(e, '年')+'月';
            //     }
            //     this.loading = true;
            //     application.getPageOfficeCanteenProcurement(this.query).then(res => {
            //         this.list = res.data;
            //         this.loading = false;
            //     }).catch(err => {
            //         this.loading = false;
            //     });
            //     this.visible = false;
            // },
            getlistdata(type='add') {
                if(this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                if(type=='new') {
                    this.list = [];
                    this.query.pageNo=1;
                    this.loading = true;
                    this.finished = false;
                }
                this.loading = true;
                application.getPageOfficeCanteenProcurement(this.query).then(res => {
                    if(res.code===200) {
                        this.list = this.list.concat(res.data);
                        this.query.pageNo++;
                        this.loading = false;
                        if(res.currentPage>=res.totalPage) {
                            this.finished = true;
                        }
                    }else {
                        this.loading = false;
                        this.finished = true;
                    }
                }).catch(() => {
                    this.loading = false;
                    this.finished = true;
                })
            },
            searchLoad() {
                this.getlistdata('new');
            },
            onRefresh(e) {
                if(e){
                    this.query.query.meetQuery = this.formatYearDate(e);
                    this.currentMonth=this.formatYearDate(e, '年')+'月';
                    this.visible = false;
                }
                this.getlistdata('new');
                this.finished = false;
                this.loading = true;
            },

        },
        mounted(){
        }
    }
</script>

<style lang="scss" scoped>
</style>